/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';

import useDataFetchIndicator from '../useDataFetchIndicator';

type HookProps = { api: vp.Api };
type HookTuple = [leads: vp.LeadsResponse, fetchData: (leadId: string) => void];
type ApiHook = (props: HookProps) => HookTuple;

const useFetchLeadsAgentId: ApiHook = ({ api }) => {
  const source = axios.CancelToken.source();
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  const [partnerId, setPartnerId] = useState('');
  const [leads, setLeads] = useState<vp.LeadsResponse>({
    Success: false,
    ErrorMessage: '',
  });

  useEffect(() => {
    const loadData = async () => {
      setDataFetchingInfo(true, 'Loading Data', 'fullScreen');

      const res = await api.fetchLeadsPartnerId({ PartnerID: partnerId, ShowToken: "1" }, source);

      if (res) {
        setLeads(res);
      }

      setDataFetchingInfo(false);
    };

    if (partnerId) void loadData();

    return () => {
      source.cancel();
    };
  }, [partnerId]);

  return [leads, (_partnerId: string) => setPartnerId(_partnerId)];
};
export default vopayApi.withApiHook<HookProps, HookTuple>(useFetchLeadsAgentId);
